  <!-- loader component -->
  <loader></loader>
  <router-outlet></router-outlet>
